import React from "react";
import Image from "next/image";
import WhatsappIcon from "@/images/whatsapp-button.svg";
import Link from "next/link";

const WhatsAppButton = () => {
  return (
    <>
      <Link
        href="https://wa.me/994552508887"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-[15px] right-[15px] z-50 cursor-pointer border-none bg-transparent sm:bottom-[20px] sm:right-[20px]"
        onClick={() => {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "whatsApp",
          });
        }}
      >
        <Image
          src={WhatsappIcon}
          alt="whatsapp-icon"
          className="h-[70px] w-[70px] sm:h-[90px] sm:w-[90px]"
          unoptimized
        />
      </Link>
    </>
  );
};

export default WhatsAppButton;
